import { createContext, useEffect, useState } from 'react'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import DeckManager from '../components/admin/DeckManager.jsx'
import { pageBg as podiumBg } from '../lib/images'

export const HostShellContext = createContext(null)

export function HostDeckShell({ children, rootPath = '/host/decks', rootLabel = 'Mes quiz' }) {
  const navigate = useNavigate()
  const location = useLocation()
  const [deckMeta, setDeckMeta] = useState(null) // { title, deckId } quand on est sur un écran de détail
  const [bgImage, setBgImage] = useState(null)
  const [headerRight, setHeaderRight] = useState(null)

  const bgStyle = {
    backgroundImage: `url(${bgImage ?? podiumBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }

  function handleBack() {
    if (location.state?.returnTo) {
      navigate(location.state.returnTo)
    } else if (deckMeta) {
      navigate(rootPath)
    } else {
      navigate('/home')
    }
  }

  return (
    <HostShellContext.Provider value={{ setDeckMeta, setBgImage, setHeaderRight }}>
      <div className="h-[100dvh] flex flex-col overflow-hidden relative" style={bgStyle}>
        <header className="relative z-10 bg-gray-900/95 backdrop-blur-sm px-4 py-3 flex items-center gap-3 shrink-0 border-b border-white/10">
          <button
            onClick={handleBack}
            className="text-white/70 hover:text-white transition p-1 rounded-lg hover:bg-white/10 shrink-0"
            aria-label="Retour"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div className="flex items-center gap-2 min-w-0 flex-1">
            <img
              src="/android-chrome-192x192.png"
              alt="KartQuiz"
              className={`w-7 h-7 rounded-lg shrink-0 ${deckMeta ? 'hidden sm:block' : ''}`}
            />
            {!deckMeta ? (
              <span className="font-semibold text-white">{rootLabel}</span>
            ) : (
              <>
                <button
                  onClick={() => navigate(rootPath)}
                  className="hidden sm:block font-semibold text-white/70 hover:text-white transition shrink-0"
                >
                  {rootLabel}
                </button>
                <span className="hidden sm:block text-white/50 shrink-0">›</span>
                <button
                  onClick={() => navigate(`${rootPath}/${deckMeta.deckId}`)}
                  className="font-semibold text-white truncate hover:text-white/80 transition"
                >
                  {deckMeta.title}
                </button>
              </>
            )}
          </div>
          {headerRight && <div className="shrink-0">{headerRight}</div>}
        </header>

        <main className="relative z-10 flex-1 overflow-y-auto p-4 md:p-8">
          <div className="max-w-6xl mx-auto w-full">
            {children}
          </div>
        </main>
      </div>
    </HostShellContext.Provider>
  )
}

export default function HostDecksPage() {
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const defaultCreateOpen = searchParams.get('create') === '1'
  const [snackbar, setSnackbar] = useState(location.state?.snackbar ?? '')

  useEffect(() => {
    if (snackbar) {
      const t = setTimeout(() => setSnackbar(''), 4000)
      return () => clearTimeout(t)
    }
  }, [snackbar])

  return (
    <HostDeckShell>
      <DeckManager
        myDecksOnly
        darkMode
        defaultCreateOpen={defaultCreateOpen}
        navBase="/host/decks"
        noLocationSnackbar
      />
      {snackbar && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-green-600 text-white px-6 py-3 rounded-full shadow-lg text-sm font-medium">
          ✅ {snackbar}
        </div>
      )}
    </HostDeckShell>
  )
}
